<div style="display: flex; align-items: center">
  <img *ngIf="!!imageSrc" [src]="imageSrc" style="margin-right: 8px;" [ngStyle]="{'width':size,'height':size}">
  <div style="display:inline-block;color: rgba(8,86,159);font-weight: bold">{{title}}</div>
</div>